import { Delete } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import { MaterialReactTable } from "material-react-table";
import { useSelector } from "react-redux";
import { tableConfig } from "../../../commons/table/config/tableConfig";
import TitleContainer from "../../../commons/table/utilsTable/titleWithFetchData";

const PrestadorTable = ({ data, loading, fetchData, handleDelete }) => {
  const roles = useSelector((state) => state.auth.roles);
  const userType = roles?.tipo;

  const canInhabilitar =
    (userType === "Supervisor Art" ||
      userType === "Administrador" ||
      Boolean(roles?.ADMIN)) &&
    userType !== "Usuario Art" &&
    userType !== "Gestor de Siniestros" &&
    userType !== "Agente de Traslados" &&
    !roles?.GESTORSINIESTROS &&
    !roles?.AGENTETRASLADOS;

  const columns = [
    {
      header: "Razón social",
      accessorKey: "nombre",
      Cell: ({ row }) => row.original.nombre,
    },
    ...(canInhabilitar
      ? [
          {
            header: "Acciones",
            id: "acciones",
            Cell: ({ row }) => (
              <Tooltip title="Deshabilitar Prestador">
                <IconButton
                  onClick={() => handleDelete(row.original)}
                  color="inherit">
                  <Delete />
                </IconButton>
              </Tooltip>
            ),
          },
        ]
      : []),
  ];

  return (
    <MaterialReactTable
      {...tableConfig}
      columns={columns}
      data={data}
      renderTopToolbarCustomActions={() => (
        <TitleContainer title="Prestadores" fetchData={fetchData} />
      )}
      state={{ isLoading: loading }}
    />
  );
};

export default PrestadorTable;
